<template>
  <div class="container">
    <img class="a1-1" src="../../../assets/img/guide/1-1.png" />
    <div class="mp4Box">
      <span class="playBtn" @click.stop="playVideo"></span>
      <img
        v-if="showBanner"
        class="videoBanner"
        src="../../../assets/img/guide/videoBanner.png"
        alt=""
      />
      <video id="player" class="mp4" controls>
        <source
          :src="
            `https://cdn.foxitreader.cn/webCDN/foxitPrint/video/install1.mp4?stamp=${Math.random()}`
          "
          type="video/mp4"
        />
      </video>
    </div>
    <div class="titleBox">
      <h3 class="no">1</h3>
      <h3 class="titleText">PC端下载【福昕智慧打印】</h3>
    </div>
    <div class="urlBox">
      <div class="url">https://www.foxitsoftware.cn/dayin/</div>
      <div class="copyBtn" @click="copyUrl">复制</div>
    </div>
    <div class="copyTips">复制链接至PC浏览器打开</div>
    <div class="titleBox">
      <h3 class="no">2</h3>
      <h3 class="titleText">成功安装福昕智慧打印客户端后，扫码登录</h3>
    </div>
    <PreViewImage
      class="a1-2 commonImg mr60"
      :src="require('../../../assets/img/guide/1-2.png')"
    />
    <div class="titleBox">
      <h3 class="no">3</h3>
      <h3 class="titleText">自动查找可用打印机</h3>
    </div>
    <PreViewImage
      class="a1-3 commonImg mr60"
      :src="require('../../../assets/img/guide/1-3.png')"
    />
    <div class="titleBox">
      <h3 class="no">4</h3>
      <h3 class="titleText">选择要添加的打印机，点击“确认添加”</h3>
    </div>
    <PreViewImage
      class="a1-4 commonImg mr60"
      :src="require('../../../assets/img/guide/1-4.png')"
    />
    <div class="titleBox">
      <h3 class="no">5</h3>
      <h3 class="titleText">设置打印机参数，便于共享使用</h3>
    </div>
    <PreViewImage
      class="a1-5 commonImg mr60"
      :src="require('../../../assets/img/guide/1-5.png')"
    />
    <div class="titleBox">
      <h3 class="no">6</h3>
      <h3 class="titleText">
        如需修改打印设备配置，支持直接修改设备名、
        使用范围、打印参数、快印码另存为/复制
      </h3>
    </div>
    <PreViewImage
      class="a1-6 commonImg mr60"
      :src="require('../../../assets/img/guide/1-6.png')"
    />
    <div class="btn" @click="toTop">免费下载</div>
    <div class="btnBlue" @click="chat">在线咨询</div>
    <div class="tipsBox">
      <h3 class="tipTitle">温馨提示</h3>
      <ul>
        <li>① 任意一台可以正常打印的电脑均支持使用。</li>
        <li>② 使用福昕智慧打印需保持电脑联网并开机。</li>
        <li>③ 一个账号可以同时添加多台打印机，USB和网络打印机都可以连接。</li>
        <li>④ 市面上绝大部分打印机设备，可以正常打印就能使用福昕智慧打印。</li>
        <li>
          ⑤
          客户端安装支持Windows系统，Mac、Linux等其他系统可以通过网页端登录使用（网页端地址：https://dy.foxitcloud.cn/）。
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import PreViewImage from "common/components/app/PreViewImage.vue";

export default {
  data() {
    return {
      showBanner: true
    };
  },
  components: {
    PreViewImage
  },
  methods: {
    copyUrl() {
      this.copy("https://www.foxitsoftware.cn/dayin/");
    },
    toTop() {
      window.scrollTo(0, 0);
    },
    playVideo() {
      this.showBanner = false;
      const player = document.getElementById("player");
      player.play();
    },
    chat() {
      Dialog.confirm({
        message: "请添加客服QQ：800802977 进行咨询",
        confirmButtonText: "复制"
      }).then(() => {
        this.copy("800802977");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 0 120px;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
}

.mp4Box {
  width: calc(100% - 64px);
  margin: 0 auto 80px;
  position: relative;
  .mp4 {
    width: 100%;
    display: block;
    max-height: 386px;
  }
  .videoBanner {
    position: absolute;
    height: 386px;
    background: white;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 10;
  }
  .playBtn {
    position: absolute;
    width: 170px;
    height: 70px;
    left: 52px;
    bottom: 90px;
    z-index: 11;
  }
}

.commonImg {
  box-shadow: 0px 5px 10px 0px rgba(3, 0, 0, 0.1);
  display: block;
  border-radius: 20px;
}

.a1-1 {
  width: 100%;
}

.titleBox {
  padding-left: 32px;
  display: flex;
  align-items: flex-start;
  .no {
    width: 44px;
    height: 44px;
    background: #2f54eb;
    border-radius: 22px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
    font-size: 26px;
    font-weight: bold;
    color: #ffffff;
    flex-shrink: 0;
  }
  .titleText {
    font-size: 30px;
    font-weight: 400;
    color: #333333;
    line-height: 42px;
    padding-right: 32px;
  }
}

.btn {
  width: 688px;
  height: 100px;
  line-height: 100px;
  background: #ffffff;
  border-radius: 50px;
  border: 1px solid #2f54eb;
  text-align: center;
  font-size: 36px;
  font-weight: 500;
  color: #2f54eb;
  margin: 0 auto 60px;
}

.btnBlue {
  width: 688px;
  height: 100px;
  line-height: 100px;
  background: #2f54eb;
  border-radius: 50px;
  border: 1px solid #2f54eb;
  text-align: center;
  font-size: 36px;
  font-weight: 500;
  color: #ffffff;
  margin: 0 auto 60px;
}

.a1-2 {
  width: 574px;
  height: 398px;
}

.a1-3 {
  width: 574px;
  height: 370px;
}

.a1-4 {
  width: 572px;
  height: 370px;
}

.a1-5 {
  width: 556px;
  height: 484px;
}

.a1-6 {
  width: 574px;
  height: 370px;
}

.mr60 {
  margin: 32px auto 60px;
}

.tipsBox {
  margin: 0 auto;
  width: 688px;
  height: 526px;
  background: rgba(255, 153, 0, 0.05);
  border-radius: 16px;
  border: 2px solid rgba(255, 153, 0, 0.5);
  padding: 36px 32px;
  .tipTitle {
    font-size: 28px;
    font-weight: bold;
    color: #ff9900;
    line-height: 28px;
    text-align: center;
    margin-bottom: 32px;
  }
  ul {
    li {
      font-size: 24px;
      font-weight: 400;
      color: #9f8967;
      line-height: 30px;
      margin-bottom: 32px;
      word-break: break-all;
    }
  }
}

.urlBox {
  width: 574px;
  height: 60px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  margin: 32px 0 26px 88px;
  justify-content: space-between;
  .url {
    flex: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 24px;
    padding: 0 26px 0 20px;
    font-weight: 500;
    color: #2f54eb;
    line-height: 60px;
  }
  .copyBtn {
    width: 108px;
    height: 60px;
    background: #2f54eb;
    border-radius: 8px;
    font-size: 26px;
    font-weight: 500;
    color: #ffffff;
    line-height: 60px;
    text-align: center;
    &:active {
      background: #0628ad;
    }
  }
}

.copyTips {
  font-size: 24px;
  font-weight: 500;
  color: #999999;
  line-height: 34px;
  margin-left: 88px;
  margin-bottom: 60px;
}
</style>
